<div class="user-section">
  <div class="table-wrapper">
    <div class="table-header gap-4">
      <div class="align-items-center flex">
        <div>
          <button pButton pRipple type="button" [disabled]="loading" class="p-button-rounded p-button-text reload-btn" (click)="getUsers()"></button>
        </div>
        <h2>User Management</h2>
        <div class="user-label">
          <img alt="user.svg" src="../../../assets/images/user.svg" />
          <span>{{ totalUsers }}</span>
        </div>
      </div>

      <div class="align-items-center flex justify-content-end gap-4">
        <div class="p-inputgroup table-search-wrapper m-0 nonio-search">
          <span class="p-inputgroup-addon"><img alt="search.svg" src="../../../assets/images/search.svg" /></span>
          <input
            (keyup)="searchUsers()"
            [(ngModel)]="searchUser"
            class="table-search-field"
            placeholder="Search user by First Name, Email, Phone Number, or Worker ID"
            type="text"
          />
        </div>
        <!--        <div *ngIf="currentAgencyRole.role == AGENCY_ADMINISTRATOR" class="bulkUpload-btn">-->
        <div class="bulkUpload-btn">
          <p-fileUpload
            #bulkUploadUsers
            (onSelect)="bulkUpload($event)"
            [auto]="true"
            [chooseIcon]="null"
            [chooseLabel]="'Upload Bulk Users'"
            [maxFileSize]="1000000"
            mode="basic"
            name="demo[]"
            class="BU-error-popup"
          ></p-fileUpload>
          <p-dropdown
            #downloadTemplateDropdown
            (onChange)="bulkUploadTemplateClick()"
            [(ngModel)]="bulkUploadTemplate"
            [autoDisplayFirst]="false"
            [options]="bulkUploadTemplateOptions"
          ></p-dropdown>
        </div>
        <p-button (click)="onAddUserClick()" *ngIf="canCreateUser()" label="Add User" styleClass="button-sm add-icon"></p-button>
      </div>
    </div>
    <p-table
      #dt
      (onLazyLoad)="customSort($event)"
      [(selection)]="selectedAgencies"
      [customSort]="true"
      [sortOrder]="-1"
      [lazy]="true"
      [rowHover]="true"
      [rowsPerPageOptions]="[10, 20, 30]"
      [rows]="10"
      [showCurrentPageReport]="true"
      [value]="users"
      class="agencyUser-table"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      dataKey="id"
    >
      <ng-template pTemplate="header">
        <tr class="gc-table-filter">
          <!--<th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>-->
          <th *ngIf="adminRoles() && isRowVisible('Agency')" class="w-8rem" id="agency">
            <div class="flex align-items-center gap-2">
              <span>Agency</span>
              <div class="filterClass">
                <img
                  class="w-16"
                  *ngIf="!selectedFilterAgency || !selectedFilterAgency.length"
                  (click)="dropdown.show()"
                  src="assets/images/filter-outline.svg"
                />
                <img
                  class="w-18"
                  *ngIf="selectedFilterAgency && selectedFilterAgency.length && selectedFilterAgency.length > 0"
                  (click)="dropdown.show()"
                  src="assets/images/filter-filled.svg"
                />
                <p-multiSelect
                  #dropdown
                  (onPanelShow)="sortSelectedValues()"
                  (onChange)="onSelectAgencyOrRole()"
                  [(ngModel)]="selectedFilterAgency"
                  [options]="agenciesFilter"
                  appendTo="body"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="typeMulitselect-dd"
                >
                  <ng-template pTemplate="header"
                    ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedFilterAgency)"
                      ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                  ></ng-template>
                </p-multiSelect>
              </div>
            </div>
          </th>
          <th *ngIf="isRowVisible('User')" class="w-8rem" id="user">
            <div class="flex align-items-center gap-2">
              <span>User</span>
              <div class="gc-filter-TCOL">
                <img
                  class="w-16"
                  *ngIf="!userFilterSelectedRows || !userFilterSelectedRows.length"
                  (click)="userFilterDropdown.show()"
                  src="assets/images/filter-outline.svg"
                />
                <img
                  class="w-18"
                  *ngIf="userFilterSelectedRows && userFilterSelectedRows.length && userFilterSelectedRows.length > 0"
                  (click)="userFilterDropdown.show()"
                  src="assets/images/filter-filled.svg"
                />
                <p-multiSelect
                  #userFilterDropdown
                  (onChange)="onSelectAgencyOrRole()"
                  [(ngModel)]="userFilterSelectedRows"
                  [displaySelectedLabel]="false"
                  [filter]="true"
                  [options]="userFilter"
                  appendTo="body"
                >
                  <ng-template pTemplate="header"
                    ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(userFilterSelectedRows)"
                      ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                  ></ng-template>
                </p-multiSelect>
              </div>
            </div>
          </th>
          <th *ngIf="isRowVisible('Email')" class="w-23rem" id="email">Email</th>
          <th *ngIf="isRowVisible('Phone')" class="w-8rem" id="phone">Phone</th>
          <th *ngIf="isRowVisible('WorkerId')" class="w-8rem" id="workerId">Worker ID</th>
          <th *ngIf="isRowVisible('Roles')" class="w-8rem" id="roles">
            <div class="flex align-items-center gap-2">
              <span>Roles</span>
              <div class="filterClass">
                <img
                  class="w-16"
                  *ngIf="!selectedRoles || !selectedRoles.length"
                  (click)="rolesDropdown.show()"
                  src="assets/images/filter-outline.svg"
                />
                <img
                  class="w-18"
                  *ngIf="selectedRoles && selectedRoles.length && selectedRoles.length > 0"
                  (click)="rolesDropdown.show()"
                  src="assets/images/filter-filled.svg"
                />
                <p-multiSelect
                  #rolesDropdown
                  (onChange)="onSelectAgencyOrRole()"
                  [(ngModel)]="selectedRoles"
                  [options]="rolesFilterOptions"
                  appendTo="body"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="typeMulitselect-dd"
                >
                  <ng-template pTemplate="header"
                    ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedRoles)"
                      ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                  ></ng-template>
                </p-multiSelect>
              </div>
            </div>
          </th>
          <th *ngIf="isRowVisible('Provider')" class="w-8rem" id="Provider">
            <div class="flex align-items-center gap-2">
              <span>Provider</span>
              <div class="filterClass">
                <img
                  class="w-16"
                  *ngIf="!selectedProvider || !selectedProvider.length"
                  (click)="providerDropdown.show()"
                  src="assets/images/filter-outline.svg"
                />
                <img
                  class="w-18"
                  *ngIf="selectedProvider && selectedProvider.length && selectedProvider.length > 0"
                  (click)="providerDropdown.show()"
                  src="assets/images/filter-filled.svg"
                />
                <p-multiSelect
                  #providerDropdown
                  (onChange)="onSelectAgencyOrRole()"
                  [(ngModel)]="selectedProvider"
                  [options]="providersFilter"
                  appendTo="body"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="typeMulitselect-dd"
                >
                  <ng-template pTemplate="header"
                    ><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedProvider)"
                      ><img src="assets/images/filter-icn.svg" alt="exclamation.svg" /></span
                  ></ng-template>
                </p-multiSelect>
              </div>
            </div>
          </th>
          <th *ngIf="isRowVisible('Status')" class="w-8rem" id="status">
            <div class="flex align-items-center gap-2">
              <span>Status</span>
              <div class="filterClass">
                <img class="w-16" *ngIf="!selectedUserStatus" (click)="statusDropdown.show()" src="assets/images/filter-outline.svg" />
                <img class="w-18" *ngIf="selectedUserStatus" (click)="statusDropdown.show()" src="assets/images/filter-filled.svg" />
                <p-dropdown
                  #statusDropdown
                  (onChange)="onChangeUserStatusFilter($event)"
                  [(ngModel)]="selectedUserStatus"
                  [autoDisplayFirst]="false"
                  [options]="userStatusFilterOptions"
                  appendTo="body"
                  styleClass="testy"
                ></p-dropdown>
              </div>
            </div>
          </th>
          <th *ngIf="isRowVisible('Last Action')" class="w-10rem" id="lastAction" pSortableColumn="lastAction">
            Last Action<p-sortIcon field="lastAction"></p-sortIcon>
          </th>
          <th *ngIf="isRowVisible('Last Activity')" class="w-10rem" id="lastActivity" pSortableColumn="lastActivity">
            Last Activity<p-sortIcon field="lastActivity">Last Activity</p-sortIcon>
          </th>
          <th *ngIf="isRowVisible('Created By')" class="w-8rem" id="createdBy">Created By</th>
          <th *ngIf="isRowVisible('Created At')" pSortableColumn="createdAt" class="w-9rem" id="created">
            Created At
            <p-sortIcon field="createdAt"></p-sortIcon>
          </th>
          <th class="flex align-center justify-content-center" id="rowsSelected">
            <div class="gc-filter-TCOL">
              <img (click)="selectRows.show()" alt="vector.svg" src="../../../assets/images/vector.svg" />
              <p-multiSelect
                #selectRows
                (onChange)="onSelectedRowsChange()"
                [(ngModel)]="selectedRows"
                [displaySelectedLabel]="false"
                [filter]="true"
                [options]="visibleRows"
                appendTo="body"
              >
                <ng-template pTemplate="header">
                  <span class="cursor-pointer close-icon" (click)="selectRows.hide()"><i class="pi pi-times"></i></span
                ></ng-template>
              </p-multiSelect>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template let-rowIndex="rowIndex" let-users pTemplate="body">
        <tr class="p-selectable-row" [class.no-permissions]="canEnablePermissionsEmail(users)" [class.no-activity]="users.noActivity">
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="adminRoles() && isRowVisible('Agency')">
            <span class="p-column-title">Agency</span>
            <span class="image-text">{{ users.agency }}</span>
            <div class="flex align-items-center gap-3">
              <div *ngFor="let agency of users?.agencyObject; let i = index" class="gc-user-agencies">
                <img *ngIf="i < 4 && agency?.picture" [src]="agency?.picture" alt="agency-picture" />
                <span *ngIf="i < 4 && !agency?.picture" class="last-agency-icon">{{ agency?.name[0] }}</span>
                <span *ngIf="i == 4" class="last-agency-icon">+{{ users?.agencyObject.length - 4 }}</span>
              </div>
            </div>
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('User')">
            <span class="p-column-title">User</span>
            <div class="flex align-items-center gap-3">
              <!--<div class="gc-user-img">
                <img src="{{ users.picture}}">
              </div>-->
              <div *ngIf="users.picture !== null && users.picture !== ''; else elseBlock" class="gc-user-img">
                <img alt="user-picture" src="{{ users.picture }}" />
              </div>
              <ng-template #elseBlock>
                <div class="gc-user-img">
                  <app-avatar [firstName]="users?.firstName" [lastName]="users?.lastName"></app-avatar>
                </div>
              </ng-template>
              <div class="">
                <p class="gc-user-name">{{ users?.firstName }} {{ users?.lastName }}</p>
                <p class="gc-user-handle">{{ users?.username }}</p>
              </div>
              <div class="">
                <span [escape]="false" [pTooltip]="createTooltip(users)" class="tooltip-icon" tooltipStyleClass="eSocMRNToolTip">
                  <img alt="exclamation.svg" src="../../../assets/images/exclamation.svg"
                /></span>
              </div>
            </div>
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Email')">
            <span class="p-column-title">Email</span>
            <span class="image-text">{{ users.email }}</span>
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Phone')">
            <span class="p-column-title">Phone</span>
            <span class="image-text"
              >{{ users.phone?.countryCode && users.phone?.number ? users.phone?.countryCode : "" }}
              {{ users.phone?.number ? users.phone?.number : "" }}</span
            >
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('WorkerId')">
            <span class="p-column-title">Worker ID</span>
            <span>{{ users?.workerId ? users?.workerId : "-----" }}</span>
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Roles')">
            <div *ngFor="let role of getAllRoles(users)">
              {{ roleEnum[role] }}
            </div>
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Provider')">
            <span>
              {{ users?.provider }}
            </span>
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Status')">
            <span class="p-column-title">Status</span>
            <span [style.color]="statusEnum[users.status] ? statusEnum[users.status] : ''" class="image-text">{{ users.status | titlecase }}</span>
          </td>
          <td *ngIf="isRowVisible('Last Action')">
            {{ users?.lastAction | customDate }}
          </td>
          <td *ngIf="isRowVisible('Last Activity')">
            {{ users?.lastActivity | customDate }}
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Created By')">
            {{ users?.createdByUser?.firstName }}
            {{ users?.createdByUser?.lastName }}
          </td>
          <td (click)="onDropDownChange(rowIndex, 'Edit')" *ngIf="isRowVisible('Created At')">
            {{ users?.createdAt | date: dateAndTimeFormat }}
          </td>
          <!-- <td>
            <span class="p-column-title"></span> -->
          <!--              <p-dropdown [options]="userDropDownOptions" [(ngModel)]="selectedItem" (onChange)="onDropDownChange(rowIndex)"-->
          <!--                          placeholder="select" appendTo="body"></p-dropdown>-->
          <!-- <button
              [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu"
              mat-icon-button
            >
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                (click)="onDropDownChange(rowIndex, 'Edit')"
                mat-menu-item
              >
                <span class="mat-opi-icon">
                  <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 7V12.75C12 12.9142 11.9677 13.0767 11.9048 13.2284C11.842 13.38 11.75 13.5178 11.6339 13.6339C11.5178 13.75 11.38 13.842 11.2284 13.9048C11.0767 13.9677 10.9142 14 10.75 14H3.25C2.91848 14 2.60054 13.8683 2.36612 13.6339C2.1317 13.3995 2 13.0815 2 12.75V5.25C2 4.91848 2.1317 4.60054 2.36612 4.36612C2.60054 4.1317 2.91848 4 3.25 4H8.48375"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.373 1.66418C14.3274 1.614 14.272 1.57361 14.2103 1.54543C14.1486 1.51726 14.0818 1.50189 14.014 1.50025C13.9461 1.49862 13.8787 1.51075 13.8157 1.53592C13.7527 1.56108 13.6954 1.59876 13.6474 1.64668L13.2608 2.03136C13.214 2.07824 13.1877 2.14181 13.1877 2.20808C13.1877 2.27436 13.214 2.33792 13.2608 2.3848L13.6152 2.73855C13.6385 2.76189 13.6661 2.78041 13.6965 2.79304C13.7269 2.80568 13.7595 2.81219 13.7924 2.81219C13.8253 2.81219 13.8579 2.80568 13.8884 2.79304C13.9188 2.78041 13.9464 2.76189 13.9696 2.73855L14.3465 2.36355C14.5371 2.17324 14.5549 1.86324 14.373 1.66418Z"
                    />
                    <path
                      d="M12.4792 2.81241L6.83798 8.44366C6.80378 8.47773 6.77892 8.52002 6.76579 8.56647L6.50486 9.34366C6.4986 9.36475 6.49816 9.38714 6.50357 9.40845C6.50899 9.42977 6.52005 9.44923 6.5356 9.46479C6.55116 9.48034 6.57062 9.49141 6.59194 9.49682C6.61326 9.50223 6.63564 9.50179 6.65673 9.49554L7.43329 9.2346C7.47975 9.22148 7.52204 9.19662 7.55611 9.16241L13.1874 3.52054C13.2395 3.46788 13.2687 3.3968 13.2687 3.32273C13.2687 3.24865 13.2395 3.17757 13.1874 3.12491L12.8764 2.81241C12.8237 2.75984 12.7523 2.73032 12.6778 2.73032C12.6034 2.73032 12.5319 2.75984 12.4792 2.81241Z"
                    />
                  </svg>
                </span>
                <span>Edit</span>
              </button>
              <button
                (click)="onDropDownChange(rowIndex, 'Delete')"
                mat-menu-item
              >
                <span class="mat-opi-icon">
                  <svg
                    fill="none"
                    height="16"
                    viewBox="0 0 16 16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.5 3.5L4.125 13.5C4.15469 14.0778 4.575 14.5 5.125 14.5H10.875C11.4272 14.5 11.8397 14.0778 11.875 13.5L12.5 3.5"
                      stroke-linejoin="round"
                    />
                    <path d="M2.5 3.5H13.5" />
                    <path
                      d="M6 3.49993V2.24993C5.99971 2.15135 6.01892 2.0537 6.05651 1.96257C6.09409 1.87145 6.14933 1.78865 6.21903 1.71895C6.28873 1.64925 6.37153 1.59402 6.46265 1.55643C6.55378 1.51884 6.65143 1.49964 6.75 1.49993H9.25001C9.34858 1.49964 9.44624 1.51884 9.53736 1.55643C9.62849 1.59402 9.71128 1.64925 9.78099 1.71895C9.85069 1.78865 9.90592 1.87145 9.94351 1.96257C9.9811 2.0537 10.0003 2.15135 10 2.24993V3.49993"
                      stroke-linejoin="round"
                    />
                    <path d="M8 5.5V12.5" stroke-linejoin="round" />
                    <path d="M5.75 5.5L6 12.5" stroke-linejoin="round" />
                    <path d="M10.25 5.5L10 12.5" stroke-linejoin="round" />
                  </svg>
                </span>
                <span>Delete</span>
              </button>
              <button (click)="changeStatus(rowIndex)" mat-menu-item>
                <mat-icon class="inactive-icon" svgIcon="status"></mat-icon>
                <span>{{
                    users.status == "Inactive" ? "Active" : "Inactive"
                  }}</span>
              </button>
            </mat-menu>
          </td> -->
          <td>
            <p-button
              class="btn-color-primaryBlue"
              *ngIf="canEnablePermissionsEmail(users)"
              (click)="onSendEmailClick(users)"
              label="Send Email"
              styleClass="button-sm"
            ></p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="11" style="text-align: center">
            <span>
              <em class="pi pi-exclamation-circle mr-2"></em>
              No User Found
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div>
      <p-paginator
        #paginator
        (onPageChange)="paginate($event)"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [rows]="noOfUsersPerRow"
        [totalRecords]="totalUsers"
        styleClass="gc-paginator"
      ></p-paginator>
    </div>
  </div>
</div>

<p-sidebar
  (onHide)="onSlideBarClose()"
  (onShow)="onSidebarShow()"
  [(visible)]="display"
  [showCloseIcon]="false"
  [dismissible]="!isSendingAppLinkEmail"
  position="right"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 class="gc-form-heading">
        {{ showEditForm ? "User Details" : "Add User" }}
      </h2>
      <span
        (click)="!isSendingAppLinkEmail && onSlideBarClose()"
        class="cursor-pointer"
        [class.disabled]="isSendingAppLinkEmail"
        [style.pointer-events]="isSendingAppLinkEmail ? 'none' : null"
      >
        <em class="pi pi-times"></em>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <form (ngSubmit)="createUser()" *ngIf="newUserForm" [formGroup]="newUserForm">
      <div class="popup-wrapper" [ngClass]="disableEditMode() ? 'disable-user-edit-popup' : ''">
        <div class="form-container">
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Contact Information</h3>
            </div>
            <div class="sidebar-form">
              <div class="gc-profile-icon">
                <div class="gc-profile-wrap">
                  <img [src]="newUserForm.value?.picture ? newUserForm.value?.picture : '../../assets/images/Subtract.svg'" alt="user-picture" />
                </div>
                <div class="flex align-items-center gap-4">
                  <p-fileUpload
                    #fileUpload
                    (onSelect)="onSelect($event)"
                    [auto]="true"
                    [chooseIcon]="null"
                    [chooseLabel]="newUserForm.value?.picture ? 'Update' : 'Upload Picture'"
                    [maxFileSize]="1000000"
                    accept="image/*"
                    mode="basic"
                    name="demo[]"
                    styleClass="change-img-btn"
                  ></p-fileUpload>
                  <p-button (click)="deleteFile()" *ngIf="newUserForm.value?.picture" label="Remove" styleClass="button-sm remove-img-btn"></p-button>
                </div>
              </div>

              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>First Name<span class="red">*</span></label>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"><img alt="input-user.svg" src="../../../assets/images/input-user.svg" /></span>
                    <input formControlName="firstName" id="firstName" name="name" pInputText placeholder="Enter first name" type="text" />
                  </span>
                  <small class="p-error" *ngIf="newUserForm.get('firstName')?.invalid && newUserForm.get('firstName')?.touched">
                    First name is required and must be at least 2 characters
                  </small>
                </div>

                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Last Name<span class="red">*</span></label>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"><img alt="input-user.svg" src="../../../assets/images/input-user.svg" /></span>
                    <input formControlName="lastName" id="lastName" name="name" pInputText placeholder="Enter last name" type="text" />
                  </span>
                  <small class="p-error" *ngIf="newUserForm.get('lastName')?.invalid && newUserForm.get('lastName')?.touched">
                    Last name is required and must be at least 2 characters
                  </small>
                </div>
              </div>

              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>Work Email<span class="red">*</span></label>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"><img alt="email-icon.svg" src="../../../assets/images/email-icon.svg" /></span>
                    <input
                      (keydown)="emailType = 'email'"
                      [disabled]="
                        newUserForm.value?.email == currentUser?.email &&
                        (currentAgencyRole.role == AGENCY_ADMINISTRATOR || currentAgencyRole.role == COMPANY_ADMIN)
                      "
                      [ngClass]="
                        newUserForm.value?.email == currentUser?.email &&
                        (currentAgencyRole.role == AGENCY_ADMINISTRATOR || currentAgencyRole.role == COMPANY_ADMIN)
                          ? 'disable-input'
                          : ''
                      "
                      [type]="emailType"
                      formControlName="email"
                      id="email"
                      pInputText
                    />
                  </span>
                  <small class="p-error" *ngIf="newUserForm.get('email')?.invalid && newUserForm.get('email')?.touched">
                    <span *ngIf="newUserForm.get('email')?.errors?.required">Email is required</span>
                    <span *ngIf="newUserForm.get('email')?.errors?.email">Please enter a valid email address</span>
                  </small>
                </div>
                <div class="col-12 md:col-6 gc-pr-12" formGroupName="phone">
                  <label>Phone<span class="red">*</span></label>
                  <div class="flex gc-dialCode">
                    <p-dropdown [options]="countries" formControlName="countryCode" optionLabel="dial_code" optionValue="dial_code">
                      <ng-template let-country pTemplate="selectedItem">
                        <span class="fi fi-{{ country.code.toLowerCase() }} countryflag"></span>
                        <span class="country-code"> {{ country.dial_code }}</span>
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <span class="fi fi-{{ country.code.toLowerCase() }} countryflag"></span>
                        <span class="country-code-dropdown"> {{ country.dial_code }}</span>
                      </ng-template>
                    </p-dropdown>
                    <p-inputMask formControlName="number" mask="999-999-9999" placeholder="(XXX) XXX-XXXX"></p-inputMask>
                  </div>
                  <small class="p-error" *ngIf="newUserForm.get('phone.number')?.invalid && newUserForm.get('phone.number')?.touched">
                    Please enter a valid phone number
                  </small>
                </div>
                <!--                <div class="col-12 md:col-6 gc-pl-12" formGroupName="fax">-->
                <!--                  <label>Fax</label>-->
                <!--                  <div class="flex gc-dialCode">-->
                <!--                    <p-dropdown [options]="countries" class="" formControlName="countryCode" optionLabel="dial_code" optionValue="dial_code">-->
                <!--                      <ng-template let-country pTemplate="selectedItem">-->
                <!--                        <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>-->
                <!--                        <span class="country-code"> {{country.dial_code}}</span>-->
                <!--                      </ng-template>-->
                <!--                      <ng-template let-country pTemplate="item">-->
                <!--                        <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>-->
                <!--                        <span class="country-code"> {{country.dial_code}}</span>-->
                <!--                      </ng-template>-->
                <!--                    </p-dropdown>-->
                <!--                    <p-inputMask formControlName="number" mask="999-999-9999" placeholder="(XXX) XXX-XXXX"></p-inputMask>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>

              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Status</label>
                  <div>
                    <p-dropdown [options]="statusValues" formControlName="status" placeholder="Select Status">
                      <ng-template let-status pTemplate="selectedItem"
                        ><span [style.color]="statusEnum[status.value] ? statusEnum[status.value] : ''">{{ status.label }}</span></ng-template
                      >
                    </p-dropdown>
                  </div>
                </div>
                <div *ngIf="currentAgencyRole?.role !== AGENCY_ADMINISTRATOR" class="col-12 md:col-6 gc-pl-12">
                  <label
                    >Company<span *ngIf="currentAgencyRole.role === SUPER_ADMIN || currentAgencyRole.role === IOH_ADMIN" class="red">*</span></label
                  >
                  <div>
                    <div class="assing-agncy">
                      <div class="assing-agncy-img">
                        <img
                          *ngIf="getCompanySelectedIcon(newUserForm.value?.companyId)"
                          [src]="getCompanySelectedIcon(newUserForm.value?.companyId)"
                          alt="company-img"
                        />
                      </div>
                      <div class="assing-agncy-filed">
                        <p-autoComplete
                          (completeMethod)="filterCompanies($event)"
                          (onSelect)="onSelectCompany($event)"
                          [disabled]="shouldDisableCompanyField()"
                          [forceSelection]="true"
                          [minLength]="1"
                          [showEmptyMessage]="true"
                          [suggestions]="filteredCompanies"
                          field="label"
                          formControlName="companyId"
                          placeholder="Company"
                        ></p-autoComplete>
                        <img *ngIf="showRemoveCompany()" alt="search.svg" src="../../../assets/images/search.svg" />
                        <img
                          (click)="removeCompany()"
                          *ngIf="showRemoveCompany()"
                          alt="Checkbox%20base.svg"
                          src="../../../assets/images/Checkbox%20base.svg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="grid p-fluid"> -->
              <!--                <div class="col-12 md:col-6">-->
              <!--                  <div class="" *ngIf="!newUserForm.value?.is_super_admin">-->
              <!--                    <label (click)="addNewAgency()">Click to add agency</label>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!-- </div> -->
            </div>
          </div>
          <div *ngIf="showEditForm && (currentUser.is_company_admin || currentUser.is_super_admin || currentUser.is_IOH_admin || this.currentAgencyRole?.role == AGENCY_ADMINISTRATOR) && userRegistrationStatus && !users[selectedIndex]?.is_company_admin" class="gc-form-section">
            <div class="gc-form-section-heading border-0">
              <h3>Activate Account</h3>
              <span (click)="sendActivationEmail()" class="resend-btn cursor-pointer">Resend Email</span>
            </div>
          </div>

          <div *ngIf="showEditForm && (currentUser.is_super_admin || this.currentAgencyRole?.role == AGENCY_ADMINISTRATOR)" class="gc-form-section">
            <div class="gc-form-section-heading border-0">
              <h3>Change Password</h3>
              <span (click)="sendResetPasswordEmail()" class="password-btn cursor-pointer">Send Reset Email</span>
            </div>
          </div>

          <div *ngIf="showEditForm && (currentUser.is_super_admin || currentUser.is_IOH_admin || currentUser.is_company_admin || this.currentAgencyRole?.role == AGENCY_ADMINISTRATOR) && (users[selectedIndex]?.defaultRole ==CLINICIAN && users[selectedIndex]?.loginWithPCIDenabled == isLoginWithPCIDEnabled) " class="gc-form-section">
            <div class="gc-form-section-heading border-0">
              <h3>Send Organization ID</h3>
              <span (click)="sendOrgIdEmail()" class="password-btn cursor-pointer">Send OrgID Email</span>
            </div>
          </div>

          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>User Settings</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div *ngIf="currentAgencyRole.role !== AGENCY_ADMINISTRATOR" class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <p-checkbox data-testid="user-settings-logging-checkbox" [binary]="true" formControlName="logging" inputId="binary" label="Logging"></p-checkbox>
                </div>
                <div *ngIf="currentAgencyRole.role !== AGENCY_ADMINISTRATOR" class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <p-checkbox data-testid="user-settings-loggingView-checkbox" [binary]="true" formControlName="loggingView" inputId="binary" label="Logging View"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 gc-pr-12">
                  <p-checkbox data-testid="user-settings-isIOHHelp-checkbox" [binary]="true" formControlName="isIOHHelp" inputId="binary" label="io Assist"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <p-checkbox data-testid="user-settings-mfa-checkbox" [binary]="true" [disabled]="!mfaEnabled" formControlName="mfa" inputId="binary" label="Enable MFA SMS"></p-checkbox>
                </div>
                <div class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <p-checkbox data-testid="user-settings-mfaToken-checkbox" [binary]="true" [disabled]="!mfaTokenEnabled" formControlName="mfa_token" inputId="binary" label="Enable MFA Token"></p-checkbox>
                </div>
                <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="col-12 md:col-6 gc-pr-12 gc-pr-12">
                  <p-checkbox
                    (onChange)="companyAdminChange()"
                    [binary]="true"
                    formControlName="is_company_admin"
                    inputId="binary"
                    label="Mark as Company Admin"
                    data-testid="user-settings-isCompanyAdmin-checkbox"
                  ></p-checkbox>
                </div>
                <div class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <p-checkbox
                    [binary]="true"
                    [disabled]="disableMultiAgencyFilter"
                    formControlName="isMultiAgenciesAllowed"
                    inputId="binary"
                    label="Multi-Agency Access"
                    data-testid="user-settings-isMultiAgenciesAllowed-checkbox"
                  ></p-checkbox>
                </div>
                <div class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <p-checkbox data-testid="user-settings-disableUpdatePopup-checkbox" [binary]="true" formControlName="disableUpdatePopup" inputId="binary" label="Disable App Update Popup"></p-checkbox>
                </div>

                 <div class="col-12 md:col-6 gc-pr-12" *ngFor="let userSetting of userSettingsLabels; let i=index" formGroupName="userSettings">
                  <p-checkbox [attr.data-testid]="'user-settings-checkbox-' + userSetting.value" [binary]="true" formControlName="{{ userSetting.value }}" inputId="binary" label="{{ userSetting.label }}" (onChange)="addExperimentModeValue(userSetting.value,$event)"></p-checkbox>
                </div>
                <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <label>DL Rules</label>
                  <p-dropdown
                    [options]="mlRulesOptions"
                    formControlName="mlRules"
                    placeholder="Select DL Rules"
                    styleClass="w-full"
                    data-testid="user-settings-mlRules-dropdown"
                  ></p-dropdown>
                </div>
                <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="col-6 md:col-6 gc-pr-6 gc-pr-6" formGroupName="userSettings">
                  <label class="mr-4" style="width: 69px">Enable/Disable QA Pre Check</label>
                  <p-dropdown
                    [ngStyle]="{'height': '50px', 'width': '162px', 'padding': '0 0'}"
                    [options]="registrationTypes"
                    formControlName="disablePreQACheck"
                    placeholder="Enable/Disable QA Pre Check"
                    styleClass="w-full"
                    data-testid="user-settings-disablePreQACheck-dropdown"
                  ></p-dropdown>
                </div>
                <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="col-6 md:col-6 gc-pr-6 gc-pr-6" formGroupName="userSettings">
                  <label class="mr-4" style="width: 69px">Enable/Disable Survey Guide</label>
                  <p-dropdown
                    [ngStyle]="{'height': '50px', 'width': '162px', 'padding': '0 0'}"
                    [options]="registrationTypes"
                    formControlName="disableSurveyGuide"
                    placeholder="Enable/Disable Survey Guide"
                    styleClass="w-full"
                    data-testid="user-settings-disableSurveyGuide-dropdown"
                  ></p-dropdown>
                </div>

                <div class="col-12 md:col-6 gc-pr-12" formGroupName="userSettings">
                  <label>Experiment Mode</label>
                  <input
                    data-testid="user-settings-experimentMode-input"
                    formControlName="experimentMode"
                    id="experimentMode"
                    name="experimentMode"
                    readonly
                    type="text"
                    pInputText
                    class="w-full"
                  />
                </div>

              </div>
            </div>
          </div>

<!--          <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="gc-form-section">-->
<!--            <div class="gc-form-section-heading">-->
<!--              <h3>User Experiment Mode Settings</h3>-->
<!--            </div>-->
<!--            <div class="sidebar-form">-->
<!--              <div class="grid p-fluid" >-->
<!--                <div class="col-12 md:col-6 gc-pr-12" *ngFor="let experimentMode of userExperimentModeLables; let i=index" formGroupName="userExperimentModes">-->
<!--                  <p-checkbox [binary]="true" formControlName="{{ experimentMode.value }}" inputId="binary" label="{{ experimentMode.label }}" (onChange)="addExperimentModeValue(experimentMode.value,$event)"></p-checkbox>-->
<!--                </div>-->

<!--&lt;!&ndash;                <div class="" formGroupName="userSettings">&ndash;&gt;-->
<!--&lt;!&ndash;                  <label>Experiment Mode</label>&ndash;&gt;-->
<!--&lt;!&ndash;                  <span class="p-input-expMode-left">&ndash;&gt;-->
<!--&lt;!&ndash;                    <input formControlName="experimentMode" id="experimentMode" name="name"  type="text" class="pInputTextExp pl-3" readonly/>&ndash;&gt;-->
<!--&lt;!&ndash;                  </span>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div
            *ngIf="!newUserForm.value?.is_super_admin && !newUserForm.value?.is_company_admin"
            [ngClass]="
              showEditForm && users[selectedIndex]?.aws_cognito_id == currentUser?.aws_cognito_id && currentAgencyRole?.role == AGENCY_ADMINISTRATOR
                ? 'disable-click'
                : ''
            "
            class="gc-form-section"
          >
            <div class="gc-form-section-heading">
              <h3>Associated Agency(s)</h3>
              <div class="flex align-items-center gap-2">
                <span class="add-associated-agency">Add Agency</span>
                <span (click)="addNewAgency()" class="add-associated-agency-plus">
                  <img alt="add associated agency" class="add-associated-agency-plus-img" src="../../../assets/images/add-associated-agency.svg" />
                </span>
              </div>
            </div>
            <div>
              <div class="sidebar-form">
                <ng-container [formArrayName]="'agency_roles'">
                  <ng-container *ngFor="let role of role?.controls; let index = index">
                    <ng-container [formGroupName]="index">
                      <div class="flex justify-content-between align-items-center">
                        <div (click)="removeAgency(index)" class="flex justify-content-start align-items-center gap-2">
                          <img alt="Checkbox%20base.svg" src="../../../assets/images/Checkbox%20base.svg" />
                          <label>Agency</label>
                        </div>
                        <div class="gc-makS-admin flex justify-content-start align-items-center gap-2">
                          <span>Mark as Default Agency <span *ngIf="!newUserForm.value.is_company_admin && !hasDefaultAgency()" class="red">*</span></span>
                          <p-checkbox
                            (onChange)="onDefaultAgencyChange(index)"
                            [binary]="true"
                            formControlName="defaultAgency"
                            inputId="binary"
                            [attr.data-testid]="'user-settings-defaultAgency-checkbox-' + index"
                          ></p-checkbox>
                        </div>
                      </div>

                      <div class="grid p-fluid mt-2 gc-add-agency">
                        <div class="w-full flex flex-wrap">
                          <div class="col-12">
                            <p-dropdown
                              [options]="agencies"
                              [filter]="true"
                              optionLabel="label"
                              optionValue="value"
                              formControlName="agency"
                              placeholder="Agency"
                              appendTo="body"
                            ></p-dropdown>
                            <!--                            <div class="assing-agncy">-->
                            <!--                              <div class="assing-agncy-img">-->
                            <!--                                <img-->
                            <!--                                  *ngIf="getSelectedIcon(index)"-->
                            <!--                                  [src]="getSelectedIcon(index)"-->
                            <!--                                  alt="agency-img"-->
                            <!--                                />-->
                            <!--                              </div>-->
                            <!--                              <div class="assing-agncy-filed">-->
                            <!--                                <p-autoComplete-->
                            <!--                                  (completeMethod)="filterAgencies($event)"-->
                            <!--                                  [forceSelection]="true"-->
                            <!--                                  [minLength]="1"-->
                            <!--                                  [showEmptyMessage]="true"-->
                            <!--                                  [suggestions]="filteredAgencies"-->
                            <!--                                  field="label"-->
                            <!--                                  formControlName="agency"-->
                            <!--                                  placeholder="Agency"-->
                            <!--                                ></p-autoComplete>-->
                            <!--                                <img-->
                            <!--                                  alt="search.svg"-->
                            <!--                                  src="../../../assets/images/search.svg"-->
                            <!--                                />-->
                            <!--                              </div>-->
                            <!--                            </div>-->
                          </div>
                          <div class="col-12">
                            <div class="flex justify-content-between align-items-center">
                              <label>Role</label>
                              <span (click)="removeChips(index)" class="remove-chips">Remove all</span>
                            </div>
                            <p-multiSelect
                              (onChange)="onSelectedRoleChange()"
                              [options]="roles"
                              display="chip"
                              formControlName="roles"
                              placeholder="Select Role"
                            ></p-multiSelect>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Add Worker ID</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-12 gc-pr-12">
                    <input formControlName="workerId" id="workerId" name="name" pInputText placeholder="Enter Worker Id" type="text" />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set NonMDM Customer Settings</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12" formGroupName="userSettings">
                  <div>
                    <p-dropdown
                    [options]="nonMdmCustomerOptions"
                    formControlName="nonMDM" placeholder="Select Option"
                    data-testid="user-settings-nonMDM-dropdown"
                    appendTo="body">
                    <ng-template let-rotationSet pTemplate="selectedItem"
                      ><span>{{ rotationSet.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
          <div *ngIf="showEditForm && isSuperAdminOnlyRole && newUserForm?.value?.userSettings?.nonMDM === NonMDMCustomerEnum.Enabled" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set App Link</h3>
              <span
                (click)="sendEmail()"
                class="resend-btn cursor-pointer"
                [class.disabled]="isSendingAppLinkEmail"
                [style.pointer-events]="isSendingAppLinkEmail ? 'none' : null"
              >
                Share APK
              </span>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Select App Link<span class="red">*</span></label>
                <p-dropdown
                  [disabled]="isFetchingAppLinks || isSendingAppLinkEmail"
                  [options]="appLinkOptions"
                  [(ngModel)]="selectedAppLinkId"
                  placeholder="Select App Link"
                  [ngModelOptions]="{standalone: true}"
                  [filter]="true"
                  appendTo="body"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="w-full app-link-dropdown"
                ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="gc-form-section" *ngIf="canActivateProviders">
            <div class="gc-form-section-heading">
              <h3>Login with PCID</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-12 gc-pr-12">
                  <p-dropdown
                    (onChange)="onPCIDChange()"
                    [options]="registrationTypes"
                    [filter]="true"
                    formControlName="loginWithPCIDenabled"
                    placeholder="Select login Type"
                    appendTo="body"
                  ></p-dropdown>
                </div>
              </div>
            </div>

            <div class="gc-form-section-heading">
              <h3>Provider Type</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-12 gc-pr-12">
                  <p-dropdown
                    [options]="providers"
                    [filter]="true"
                    formControlName="provider"
                    placeholder="Select Provider"
                    appendTo="body"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="gc-form-section" *ngIf="currentAgencyRole.role === SUPER_ADMIN || currentAgencyRole.role === IOH_ADMIN">
            <div class="gc-form-section-heading">
              <h3>Note</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-12 gc-pr-12">
                  <textarea
                    formControlName="note"
                    id="note"
                    placeholder="Enter note here..."
                    style="width: 100%"
                    class="h-7rem"
                    pInputText
                    pInputTextarea
                    rows="5"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>





          <!--          <div class="gc-form-section" *ngIf="showEditForm">-->
          <!--            <div class="gc-form-section-heading">-->
          <!--              <h3>Change Password</h3>-->
          <!--              <span class="password-text">Change Password</span>-->
          <!--            </div>-->
          <!--            <div class="sidebar-form">-->
          <!--              <div class="grid p-fluid">-->
          <!--                <div class="col-12 md:col-6 gc-pr-12"></div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <!--          <div class="gc-form-section" formGroupName="address">-->
          <!--            <div class="gc-form-section-heading">-->
          <!--              <h3>Address</h3>-->
          <!--            </div>-->
          <!--            <div class="sidebar-form">-->
          <!--              <div class="grid p-fluid">-->
          <!--                <div class="col-12 md:col-6 gc-pr-12">-->
          <!--                  <label>Line 1<span class="red">*</span></label>-->
          <!--                  <input formControlName="line1" id="line1" name="line1" pInputText-->
          <!--                         placeholder="Line 1" type="text"/>-->
          <!--                </div>-->
          <!--                <div class="col-12 md:col-6 gc-pl-12">-->
          <!--                  <label>Line 2</label>-->
          <!--                  <input formControlName="line2" id="line2" name="line2" pInputText-->
          <!--                         placeholder="Line 2" type="text"/>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="grid p-fluid">-->
          <!--                <div class="col-12 md:col-6 gc-pr-12">-->
          <!--                  <label>Country<span class="red">*</span></label>-->
          <!--                  <div class="flex">-->
          <!--                    <p-dropdown [options]="countries" class="w-full" formControlName="country" optionLabel="name" optionValue="name">-->
          <!--                      <ng-template let-country pTemplate="item">-->
          <!--                        <span class="country-code"> {{country.name}}</span>-->
          <!--                      </ng-template>-->
          <!--                    </p-dropdown>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="col-12 md:col-6 gc-pl-12">-->
          <!--                  <label>City<span class="red">*</span></label>-->
          <!--                  <input formControlName="city" id="addressCity" name="addressCity" pInputText-->
          <!--                         placeholder="City" type="text"/>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="grid p-fluid">-->
          <!--                <div class="col-12 md:col-6 gc-pr-12">-->
          <!--                  <label>State</label>-->
          <!--                  <input formControlName="state" id="addressState" name="addressState" pInputText-->
          <!--                         placeholder="State" type="text"/>-->
          <!--                </div>-->
          <!--                <div class="col-12 md:col-6 gc-pl-12">-->
          <!--                  <label>Zipcode</label>-->
          <!--                  <input formControlName="postalCode" id="postalCode" name="postalCode" pInputText-->
          <!--                         placeholder="Zipcode" type="text"/>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        </div>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button
        (click)="onDeleteClick()"
        *ngIf="showEditForm"
        class="btn-delete"
        label="Delete"
        [disabled]="disableEditMode() || isSendingAppLinkEmail"
        pButton
      ></button>

      <button
        (click)="onSlideBarClose()"
        class="btn-cancel"
        label="Cancel"
        [disabled]="isSendingAppLinkEmail"
        pButton
      ></button>

      <button
        (click)="validateAndSubmit()"
        *ngIf="!showEditForm"
        [disabled]="isSubmitting"
        label="Add"
        pButton
        type="button"
      >
        <i *ngIf="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
      </button>

      <button
        (click)="validateAndUpdate()"
        *ngIf="showEditForm"
        [disabled]="
          isSubmitting ||
          isSendingAppLinkEmail ||
          (currentAgencyRole.role == COMPANY_ADMIN && users[selectedIndex].is_company_admin) ||
          (newUserForm.value?.email == currentUser?.email &&
            (currentAgencyRole.role == AGENCY_ADMINISTRATOR || currentAgencyRole.role == COMPANY_ADMIN))
        "
        label="Update"
        pButton
        type="button"
      >
        <i *ngIf="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
      </button>
    </div>
  </ng-template>
</p-sidebar>
<!-- Dialog for successful user creation -->
<p-dialog [(visible)]="showUserCreationSuccessPopup" [dismissableMask]="true" [modal]="true" [style]="{ width: '320px' }" class="addUser-popup">
  <div class="flex align-items-center flex-column gap-3">
    <img alt="successful.gif" class="w-12rem" src="../../../../assets/images/successful.gif" />
    <h3 class="text-center">Congratulations!</h3>
    <p class="text-center">Congrats! email with username and temporary password sent!</p>
  </div>
</p-dialog>
